import { useMocks } from '../../shared/env';
import type { BenefitsGateway } from './BenefitsGateway';
import type { CatalogGateway } from './CatalogGateway';
import type { DeductionsGateway } from './DeductionsGateway';
import { HttpBenefitsGateway } from './HttpBenefitsGateway';
import { HttpCatalogGateway } from './HttpCatalogGateway';
import { HttpDeductionsGateway } from './HttpDeductionsGateway';
import { MockBenefitsGateway } from './MockBenefitsGateway';
import { MockCatalogGateway } from './MockCatalogGateway';
import { MockDeductionsGateway } from './MockDeductionsGateway';

export const benefitsGateway: BenefitsGateway = useMocks ? new MockBenefitsGateway() : new HttpBenefitsGateway();
export const deductionsGateway: DeductionsGateway = useMocks ? new MockDeductionsGateway() : new HttpDeductionsGateway();
export const catalogGateway: CatalogGateway = useMocks ? new MockCatalogGateway(benefitsGateway, deductionsGateway) : new HttpCatalogGateway();
export type { BenefitsGateway } from './BenefitsGateway';
export type { CatalogGateway } from './CatalogGateway';
export type { DeductionsGateway } from './DeductionsGateway';
